import React from "react";
import { sidemenuFooterWrap } from "../componentCommon";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import "../../index.scss";
import "./Responsive.scss";
import "../App.css";
import "./Copyright.scss";

const CopyrightText = () => (
  <div className="copyright-text" style={{ fontWeight: "normal" }}>
    <Row>
      <Col
        sm={{ span: 12 }}
        md={{ span: 11, offset: 1 }}
        lg={{ span: 11, offset: 1 }}
        xl={{ span: 11, offset: 0 }}
      >
        <p style={{ color: "dimgray" }}>
          Poštovani autori i nosioci autorskih prava,
          <br />
          <br />
          Želimo da Vam se izvinimo što nismo stigli da se svakom od vas javimo
          pre postavljanja prezentacije na internet.
          <br />
          Zbog kompleksnosti projekta ali i broja tekstova nije bilo moguće da
          dođemo do svakog od Vas.
          <br />
          Želeli bismo da naglasimo da je ovaj projekat izrazito edukativnog
          karaktera i ni na koji način nije komercijalan.
          <br />
          Ideja nam je bila da omogućimo što većem broju zainteresovanih da
          pročitaju tekstove do kojih, na žalost, nije lako doći.          
          <br />
          Iz tog razloga smo odlučili da postavimo prezentaciju na internet i da
          Vas naknadno kontaktiramo.
          <br />
          Nadamo se da ćete podržati našu želju da putem prezentacije fonda
          Odeljenja za umetničku dokumentaciju informacije o našim umetnicima
          učinimo dostupnim.
          <br />
          Po dogovoru sa vama, na ovom mestu će se naći{" "}
          <b className="copyright-conditions">Uslovi korišćenja</b> materijala
          na sajtu. Naš predlog je <i>Creative Commens</i> licenca "autorstvo -
          nekomercijalno - deliti pod istim uslovima". Ova licenca zabranjuje
          komercijalnu upotrebu i preradu dela.
          <br />O detaljima ove licence se možete obavestiti na sajtu{" "}
          <a href="http://creativecommons.org.rs" target="_blank" rel="noreferrer">
            http://creativecommons.org.rs
          </a>
          .
          <br />
          <br />
          Za sva pitanja, sugestije i primedbe možete se obratiti na e-mail:{" "}
          <font color="black">biblioteka@msub.org.rs</font>.
          <br />
          <br />
          Hvala na razumevanju.
        </p>
      </Col>
    </Row>
  </div>
);

const Copyright = sidemenuFooterWrap(CopyrightText);
export default Copyright;
